<style>
    .trade-info .el-form-item {
        margin-bottom: 0px;
    }
</style>
<template>
    <el-card class="box-card mt15 trade-info">
        <template slot='header'>
        <div>
            <span v-if="status > 1">回款登记单对账</span>
            <el-form :inline="true" v-else>
                <el-form-item label="回款登记单对账">
                    <ly-auto-search 
                        :json="json" 
                        :other="otherForm" 
                        :is-init-search="true"
                        v-model="infoData" placeholder="请选择或输入回款登记单号">
                    </ly-auto-search>
                </el-form-item>
            </el-form>
        </div>
        </template>
        <ly-information 
            :config="infoConfig"
            :data="infoData">        
        </ly-information>

        <ly-table 
            :head="customerConfig.head" 
            :data="infoData.customer" 
            :config="customerConfig.config"
            class="mt15">
        </ly-table>

    </el-card>
</template>
<script>
    import LyAutoSearch from '@c/auto-search'
    import LyInformation from '@c/information'
    import LyTable from '@c/table'

    export default {
        components: {
            LyAutoSearch,
            LyInformation,
            LyTable
        },
        props: {
            status: [String, Number], // 单据的状态
            data: {
                type: Object,
                default: () => {}
            },
            number: [String, Number], // 银行账号
            amount: [String, Number] // 收支金额
        },
        data () {
            return {
                infoData: {}, // 选中的回款登记单
                otherForm: {}, // 额外的查询参数
                json: {
                    size: 'small',
                    api: 'api/paycheckinlist',
                    prop: 'transaction_no_display',
                    fields: [{
                        label: '登记单号',
                        prop: 'transaction_no_display',
                    }]
                },
                infoConfig: [
                    {"label":"开单日期","prop":"work_time"},
                    {"label":"回款日期","prop":"huikuan_time"},
                    {"label":"登记单号","prop":"transaction_no_display"},
                    {"label":"收款账户","prop":"shoukuanzh_name"},
                    {"label":"收款金额","prop":"shoukuan_amount"},
                    {"label":"登记人","prop":"dengjiren"},
                    {"label":"摘要","prop":"zhaiyao", "colspan":5}
                ], // 对账详情信息的配置
                customerConfig: {
                    config: {
                        isNumber: true
                    },
                    head: [
                        {
                            "prop": "customer_account",
                            "label": "客户编码"
                        }, {
                            "prop": "customer_name",
                            "label": "客户名称"
                        }, {
                            "prop": "huikuan_amount",
                            "label": "实收/实退金额",
                            "width": 220
                        },{
                            "prop": "shouxufei",
                            "label": "手续费"
                        }, {
                            "prop": "weidu_name",
                            "label": "核算纬度"
                        }, {
                            "prop": "employee_name",
                            "label": "单据业务员"
                        }, {
                            "prop": "remark",
                            "label": "备注"
                        }
                    ]
                } // 客户列表信息的配置
            }
        },
        watch: {
            data (val) {
                this.init()
            }
        },
        created () {
            this.init()
        },
        methods: {
            init () {
                if (String(this.status) !== '1') {
                    this.infoData = this.data
                }
                this.otherForm = {
                    account_number: this.number,
                    amount: this.amount
                }
            },
            /**
             * 数据验证
             */
            validate () {
                if (this.infoData.transaction_no_display && this.infoData.transaction_no_display.length > 0) {
                    return true
                } else {
                    this.$message({
                        message: '未选择回款登记单，请选择后进行提交！',
                        type: 'warning'
                    })
                    return false
                }
            },
            /**
             * 获得数据
             */
            getData () {
                return {
                    huikuang_transaction_no_display: this.infoData.transaction_no_display
                }
            }
        }
    }
</script>